/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';
import { presets } from './presets';

export type DropdownProps = Omit<ISmartProps, 'css'>;

export const Dropdown = React.forwardRef((props: DropdownProps, ref: any) => {
	const getPresets = presets(null);
	const setPreset = props.preset ? getPresets[props.preset] : {};

	return <View {...setPreset} {...props} ref={ref} />;
});
